import { render, staticRenderFns } from "./UiAuthentication.vue?vue&type=template&id=8d9ae5c8"
import script from "./UiAuthentication.vue?vue&type=script&lang=js"
export * from "./UiAuthentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports